module.exports = __webpack_public_path__ + "static/img/no_order.59fdda2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/no_order.png
// module id = jHTj
// module chunks = 1